import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

/**
 * THIS MUST BE DITOKEN BECAUSE WE USE IT IN STANDARD FUNCTIONS FOR ROUTING
 */

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CMS_SITES_LINKS_MAPPER: DiToken<Record<string, string | undefined>> = new DiToken<
  Record<string, string | undefined>
>('CmsSitesLinksMapper', {
  factory: (): Record<string, string | undefined> => {
    return {};
  }
});
